import { DirectDonationsHeader } from "./DirectDonationsHeader";
import { DirectDonationsList } from "./DirectDonationsList";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DirectDonations(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-6",
    children: [/*#__PURE__*/_jsx(DirectDonationsHeader, {}), /*#__PURE__*/_jsx(DirectDonationsList, {
      contributions: props.contributions
    })]
  });
}